/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:49:42
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-03 11:20:14
 */
import buttonInfo from '@/app/editor/sidebar/elementsInfo/button';
import headingInfo from '@/app/editor/sidebar/elementsInfo/heading';
import textBlockInfo from '@/app/editor/sidebar/elementsInfo/textBlock';
import submitButtonInfo from '@/app/editor/sidebar/elementsInfo/submitButton';
import iconInfo from '@/app/editor/sidebar/elementsInfo/icon';
import imageInfo from '@/app/editor/sidebar/elementsInfo/image';
import separatorInfo from '@/app/editor/sidebar/elementsInfo/separator';
import textFieldInfo from '@/app/editor/sidebar/elementsInfo/textField';
import emailFieldInfo from '@/app/editor/sidebar/elementsInfo/emailField';
import textareaInfo from '@/app/editor/sidebar/elementsInfo/textarea';
import dropdownInfo from '@/app/editor/sidebar/elementsInfo/dropdown';
import checkboxInfo from '@/app/editor/sidebar/elementsInfo/checkbox';

export default {
  buttonInfo,
  headingInfo,
  textBlockInfo,
  submitButtonInfo,
  iconInfo,
  imageInfo,
  separatorInfo,
  textFieldInfo,
  emailFieldInfo,
  textareaInfo,
  dropdownInfo,
  checkboxInfo,
};
